import { Api } from './api';
import { normalizeProducts } from './productNormalizer';

const normalizeCollection = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  return [];
};

const normalizeBrands = (payload) =>
  normalizeCollection(payload).map((brand, index) => ({
    id: brand.brand_id ?? brand.id ?? `brand-${index}`,
    name: brand.name || brand.title || `Brand ${index + 1}`,
    logo: brand.logo || brand.image || null,
  }));

const normalizeCategories = (payload) =>
  normalizeCollection(payload).map((category, index) => ({
    id: category.categoryId ?? category.id ?? `category-${index}`,
    name: category.name || category.title || `Category ${index + 1}`,
  }));

const includesQuery = (value, query) =>
  String(value || '').toLowerCase().includes(query.toLowerCase());

export const searchAll = async (query) => {
  const trimmed = String(query || '').trim();
  if (!trimmed) {
    return { products: [], brands: [], categories: [] };
  }

  const [productsPayload, brandsPayload, categoriesPayload] = await Promise.all([
    Api.fetchProducts(),
    Api.fetchBrands(),
    Api.fetchCategories(),
  ]);

  const normalizedProducts = normalizeProducts(productsPayload).filter(
    (product) =>
      includesQuery(product.name, trimmed) ||
      includesQuery(product.brand, trimmed)
  );

  const normalizedBrands = normalizeBrands(brandsPayload).filter((brand) =>
    includesQuery(brand.name, trimmed)
  );

  const normalizedCategories = normalizeCategories(categoriesPayload).filter(
    (category) => includesQuery(category.name, trimmed)
  );

  return {
    products: normalizedProducts,
    brands: normalizedBrands,
    categories: normalizedCategories,
  };
};

export default searchAll;
